import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TranslateIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItemOption,
  MenuOptionGroup,
} from "@chakra-ui/react";

const defaultLng = "en";
const LanguageSelect = ({ handleLanguageChange }) => {
  const [selectedLng, setSelectedLng] = useState(defaultLng);
  const { i18n } = useTranslation();
  const [lngs, setLngs] = useState(null);

  function onLangChange(lang) {
    i18n.changeLanguage(lang).then(() => {
      setSelectedLng(lang);
      handleLanguageChange();
    });
  }

  useEffect(() => {
    if (!lngs) {
      i18n.services.backendConnector.backend.backends[1].getLanguages(
        (err, ret) => {
          if (err) return; // TODO: handle err...
          setLngs(ret);
        }
      );
    }
  }, [lngs]);

  if (!lngs) return null;
  return (
    <Box position={"absolute"} top={8} right={8}>
      <Menu
        closeOnSelect={true}
        direction="rtl"
        placement={"bottom"}
        matchWidth
      >
        <MenuButton
          as={Button}
          minW={"140px"}
          pl={2}
          leftIcon={
            <Box bg={"#fff"} borderRadius={"full"} p={2}>
              <TranslateIcon width={"20px"} />
            </Box>
          }
          borderRadius={"30px"}
          size={"lg"}
        >
          {lngs[selectedLng].nativeName.split(",")[0]}
        </MenuButton>
        <MenuList minW="auto" borderRadius={"30px"} overflow={"hidden"}>
          <MenuOptionGroup
            defaultValue={selectedLng}
            type="radio"
            onChange={onLangChange}
            color={"black"}
          >
            {Object.keys(lngs).map((key) => {
              let lng = lngs[key].nativeName.split(",")[0];
              return (
                <MenuItemOption
                  p={2}
                  key={key}
                  value={key}
                  color={"brand.primary.400"}
                  fontWeight={"semibold"}
                  fontSize={"lg"}
                >
                  {lng}
                </MenuItemOption>
              );
            })}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};

LanguageSelect.propTypes = {
  handleLanguageChange: PropTypes.func,
};

export default LanguageSelect;
